const humanReadableChannelNames = new Map([
    ['widgetchat', 'Chat'],
    ['messenger', 'Dixa Messenger'],
    ['pstnphone', 'Phone'],
    ['email', 'Email'],
    ['contactform', 'Contact Form'],
    ['voicemail', 'Voicemail'],
    ['callback', 'Callback'],
    ['facebookmessenger', 'Facebook Messenger'],
    ['whatsapp', 'WhatsApp'],
    ['sms', 'Texts'],
    ['twitter', 'Twitter'],
]);
export function getChannelName(channel) {
    return humanReadableChannelNames.has(channel)
        ? humanReadableChannelNames.get(channel)
        : 'Unknown Channel';
}
